//  shadi-arts-portfolio Firebase\client\src\components\Admin\AdminLayout.jsx

import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import DashboardStats from "./DashboardStats";
import ArtworkManager from "./ArtworkManager";
import OrderManager from "./OrderManager";
import PricingManager from "./PricingManager";
import { useLanguage } from "../../context/LanguageContext";
import AnalyticsDashboard from "./AnalyticsDashboard";

const AdminLayout = () => {
  const [activeTab, setActiveTab] = useState("stats");
  const { logout } = useAuth();
  const { t } = useLanguage();

  const tabs = [
    { id: "stats", label: t("📊 Dashboard", "📊 لوحة التحكم"), icon: "📊" },
    {
      id: "artworks",
      label: t("🖼️ Artworks", "🖼️ الأعمال الفنية"),
      icon: "🖼️",
    },
    { id: "orders", label: t("📦 Orders", "📦 الطلبات"), icon: "📦" },
    { id: "pricing", label: t("💰 Pricing", "💰 التسعير"), icon: "💰" },
    { id: "analytics", label: t("📈 Analytics", "📈 التحليلات"), icon: "📈" },
  ];

  return (
    <div className="admin-layout">
      <div className="admin-sidebar">
        <div className="admin-logo">
          <h2>🎨 Shadi Arts</h2>
          <p>Admin Dashboard</p>
        </div>

        <nav className="admin-nav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`nav-item ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="nav-icon">{tab.icon}</span>
              <span className="nav-label">{tab.label}</span>
            </button>
          ))}
        </nav>

        <button onClick={logout} className="logout-btn">
          🚪 {t("Logout", "تسجيل الخروج")}
        </button>
      </div>

      <div className="admin-content">
        <div className="admin-header">
          {/* <h1>{tabs.find(t => t.id === activeTab)?.label}</h1> */}
          <h1>{tabs.find((t) => t.id === activeTab)?.label || "Dashboard"}</h1>
        </div>

        <div className="admin-body">
          {activeTab === "stats" && <DashboardStats />}
          {activeTab === "artworks" && <ArtworkManager />}
          {activeTab === "orders" && <OrderManager />}
          {activeTab === "pricing" && <PricingManager />}
          {activeTab === "analytics" && <AnalyticsDashboard />}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
